export const isVideoSource = (source: string) => /\.(mp4|m4v|mov|webm|mkv|avi|ogv|ogg)(?:[?#]|$)/i.test(source);

export const indexAfterRemoval = (current: number, removed: number, length: number) =>
  current > removed ? current - 1 : current === removed ? Math.max(0, Math.min(removed, length - 2)) : current;
